import { Locale, localeOptions } from '../api/core/core.types';

export function getLanguageName(value: Locale) {
  const locale = localeOptions.find((l) => l.value === value);
  if (locale) return locale.label;

  return value.toString();
}
